import { CanadaPurchaseCost } from '../purchase-cost'

export const QuebecPurchaseCost = {
  ...CanadaPurchaseCost,
} as const
